import CalendarTodayOutlined from '@mui/icons-material/CalendarTodayOutlined';
import { Box } from '@mui/material';
import { prettyDate } from 'shared/utils/format';
import DESIGN_COLORS from 'shared/_ui/design-colors';

type ListItemCreatedProps = {
	value?: string;
	/** Hides the date below the `sm` breakpoint. */
	hideOnMobile?: boolean;
};

/** Created date of a list item: calendar icon + date, muted. */
export default function ListItemCreated({ value, hideOnMobile }: ListItemCreatedProps) {
	return (
		<Box
			title="Created"
			sx={{
				display: { xs: hideOnMobile ? 'none' : 'flex', sm: 'flex' },
				alignItems: 'center',
				gap: 2,
				minWidth: 0,
				color: DESIGN_COLORS.muted,
				fontSize: '0.8125rem',
				whiteSpace: 'nowrap',
				'& > .MuiSvgIcon-root': { flexShrink: 0, fontSize: '1rem', color: DESIGN_COLORS.faint },
			}}
		>
			<CalendarTodayOutlined />
			{prettyDate(value)}
		</Box>
	);
}
